// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__W97CF","inputWrap":"styles_inputWrap__33k5n","input":"styles_input__26Vde"};